export default __webpack_public_path__ + "media/images/31-0c53660e5635b3f89054b53535d1f758.jpg";